import CalendarViewMonthOutlinedIcon from "@mui/icons-material/CalendarViewMonthOutlined";
import IrrDetailsIcon from "./IrrDetailsIcon.tsx";
import { ReportType } from "../../../../../../../../api/types/svTypes.ts";
import AreaChartIcon from "./AreaChartIcon.tsx";
import BarChartIcon from "./BarChartIcon.tsx";
import DoughnutChartIcon from "./DoughnutChartIcon.tsx";
import FinancialStatementReportIcon from "./FinancialStatementReportIcon.tsx";
import LineChartIcon from "./LineChartIcon.tsx";
import PieChartIcon from "./PieChartIcon.tsx";
import PivotIcon from "./PivotIcon.tsx";
import TabularIcon from "./TabularIcon.tsx";
import TileIcon from "@entrilia/shared/icons/TileIcon.tsx";

const getReportTypeIcon = (reportType: ReportType | undefined) => {
  switch (reportType) {
    case ReportType.CashFlow:
      return <IrrDetailsIcon />;
    case ReportType.Tabular:
      return <TabularIcon />;
    case ReportType.Pivot:
      return <PivotIcon />;
    case ReportType.BarChart:
      return <BarChartIcon />;
    case ReportType.LineChart:
      return <LineChartIcon />;
    case ReportType.AreaChart:
      return <AreaChartIcon />;
    case ReportType.PieChart:
      return <PieChartIcon />;
    case ReportType.DoughnutChart:
      return <DoughnutChartIcon />;
    case ReportType.Tile:
      return <TileIcon />;
    case ReportType.List:
      return <CalendarViewMonthOutlinedIcon />;
    case ReportType.FinancialStatement:
      return <FinancialStatementReportIcon />;
    default:
      return undefined;
  }
};

export default getReportTypeIcon;
